import React from 'react'
import { Link } from 'react-router-dom'

import { Header, HeaderButtons } from '../LayoutStyles'
import NavLink from '../NavLink'
import UserDropDown from '../UserDropDown'
import { LinkButton } from '../../Styled/Shared'

const ProductLogo = require('./PD_DBS_logo_blue.svg')

const LayoutHeader = ({ pathname }) => (
  <Header>
    <div className="header-pop">
      <h1>
        <Link to="/">
          <img src={ProductLogo} alt="DELTABEAM SELECT(r)" />
        </Link>
      </h1>
      <HeaderButtons>
        <a className="linkLink" href="https://www.peikko.com/products/deltabeam-slim-floor-structures/overview/" target="_blank">
          <div className="linkText">PRODUCT</div>
        </a>
        <a className="linkLink" href="https://www.peikko.com/references/" target="_blank">
          <div className="linkText">REFERENCES</div>
        </a>
        <NavLink to="about">About</NavLink>
        <div className="spacer200" />
        <UserDropDown />
      </HeaderButtons>
      <LinkButton
        style={{ height: '40px', lineHeight: '40px', fontSize: '13px' }}
        to="#contacts"
      >
        Contact Peikko
      </LinkButton>
    </div>
  </Header>
)

export default LayoutHeader



// WEBPACK FOOTER //
// ./src/Components/Layout/LayoutHeader/index.tsx